import { createSlice } from "@reduxjs/toolkit";
import { createAsyncCases } from "../../../helpers/reduxUtils";
import {
  fetchLocations,
  addLocation,
  updateLocation,
  getLocationById,
  getLocations,
} from "../../../api/location/locationThunk";
const initialState = {
  items: [],
  status: "idle",
  loading: false,
  error: null,
  totalRowsCount: 0,
  selectedItem: null,
  locationsForDropdown: [],
};
const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    handleSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
  },
  extraReducers(builder) {
    createAsyncCases(builder, fetchLocations, {
      fulfilled(state, action) {
        state.items = action?.payload?.data;
        state.totalRowsCount = action?.payload?.pagination?.totalRowsCount;
      },
    });
    createAsyncCases(builder, addLocation, {
      fulfilled(state, action) { },
    });
    createAsyncCases(builder, updateLocation, {
      fulfilled(state, action) { },
    });
    createAsyncCases(builder, getLocationById, {
      fulfilled(state, action) { },
    });

    createAsyncCases(builder, getLocations, {
      fulfilled(state, action) {
        state.locationsForDropdown = action?.payload;
      },
    });
  },
});

export default locationSlice.reducer;
export const { handleSelectedItem } = locationSlice.actions;
